import { ChartProps } from 'react-chartjs-2';
import { sum } from 'lodash';

import { createArrayFromNumber } from '~utils/commons';

type VisitsPerDayChartProps = ChartProps<'bar', number[], number>;

export const getVisitsPerDayChartProps = ({
  visitTotalCount,
  visitCompletedCount,
  visitFailCount,
  visitPending,
}: {
  visitCompletedCount: number[];
  visitFailCount: number[];
  visitPending: number[];
  visitTotalCount: number[];
}): VisitsPerDayChartProps => {
  const labels = createArrayFromNumber(visitTotalCount.length, false);

  const data: VisitsPerDayChartProps['data'] = {
    labels: labels,
    datasets: [
      {
        label: `Completas (${sum(visitCompletedCount)})`,
        data: visitCompletedCount,
        backgroundColor: '#49CC90',
      },
      {
        label: `Incompletas (${sum(visitFailCount)})`,
        data: visitFailCount,
        backgroundColor: '#F93E3E',
      },
      {
        label: `Cierre forzoso (${sum(visitPending)})`,
        data: visitPending,
        backgroundColor: '#FCA130',
      },
    ],
  };

  const options: VisitsPerDayChartProps['options'] = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          boxWidth: 15,
          boxHeight: 15,
          usePointStyle: true,
        },
      },
    },
    interaction: {
      mode: 'index',
      intersect: false,
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        display: false,
      },
    },
    maintainAspectRatio: false,
  };

  return { data, options, type: 'bar' };
};
